import { FC } from 'react'
import { PriceCardDeprecated, PriceCard } from '@/root/modules/shared/SelectTicketPage/'
import { Price } from '@/root/shared-types/dto/SailPricing'
import { CartItemSailParam } from '@/root/shared-providers/BookingCart/types'
import { CountryItem, Locale } from '@/root/shared-types'
import { AddCartItem } from '@/root/shared-providers/BookingCart/types'
import * as R from 'ramda'

interface PriceCardListDeprecatedProps {
  handleClick: (price: Price) => void
  locale: Locale
  maxTicketQty: number
  prices: Array<Price>
  countries?: CountryItem[]
  departureDate?: string
  handleDec?: (item: AddCartItem) => void
  handleInc?: (item: AddCartItem) => void
  passengerId?: string
  priceCategoriesInCart?: string[]
  priceFilter?: (price: Price) => boolean
  route?: string
  sailPackages?: CartItemSailParam[]
  status?: string
  ticketTitle?: string
}

export const PriceCardListDeprecated: FC<PriceCardListDeprecatedProps> = ({
  locale,
  prices,
  countries = [],
  priceFilter,
  status,
  passengerId = '',
  priceCategoriesInCart = [],
  sailPackages = [],
  handleInc,
  handleDec,
  handleClick,
  route,
  departureDate,
  maxTicketQty,
}) => {
  const filteredByPrice = prices.filter(priceFilter ?? R.T)

  const isResidentMode = filteredByPrice.length > 0 && filteredByPrice.every((p) => p.priceCategory.isResident)

  const setOn = true
  return (
    <ul className="flex w-full flex-col gap-5">
      {isResidentMode ? (
        <div className="flex flex-col gap-2">
          <PriceCard
            price={filteredByPrice[0]}
            countries={countries}
            route={route}
            departureDate={departureDate}
            maxTicketQty={maxTicketQty}
          />
        </div>
      ) : (
        filteredByPrice.map((price) => (
          <div key={'price-' + price.priceCategory.code} className="flex flex-col gap-2">
            <PriceCard
              price={price}
              countries={countries}
              route={route}
              departureDate={departureDate}
              maxTicketQty={maxTicketQty}
            />

            {setOn && (
              <PriceCardDeprecated
                key={price.priceCategory.code}
                price={price.calculatedPrice}
                title={price.priceCategory.titles[locale]}
                priceSource={price}
                disabled={status === 'OFFER'}
                withQuantity={priceCategoriesInCart.includes(price.priceCategory.code)}
                handleInc={() =>
                  handleInc &&
                  handleInc({
                    quantity: 1,
                    type: price.priceCategory.type,
                    subType: price.priceCategory.subType,
                    title: price.priceCategory.title,
                    price: price.calculatedPrice,
                    priceCategory: price.priceCategory.code,
                    passengerId,
                    sailPackages,
                  })
                }
                handleDec={
                  handleDec &&
                  (() =>
                    handleDec({
                      quantity: 1,
                      type: price.priceCategory.type,
                      subType: price.priceCategory.subType,
                      title: price.priceCategory.title,
                      price: price.calculatedPrice,
                      priceCategory: price.priceCategory.code,
                      passengerId,
                      sailPackages,
                    }))
                }
                handleClick={() => handleClick(price)}
              />
            )}
          </div>
        ))
      )}
    </ul>
  )
}

export default PriceCardListDeprecated
